define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi/def/Relationship",
	"csi/view/ToolbarPluginSwitchboard"
], function(declare,lang,_,Relationship,ToolbarPluginSwitchboard) {

	return declare(ToolbarPluginSwitchboard, {
		disableButtonAction: true,
		idViewProperty: "selectedResponse",
		resDefault: "SelectOne",
		refreshStoreOptions: true,
		switchboardPath: "Child:SupplierSpecResponseRevs/Child:Master",
		hideGo: true
	});
});